import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetChannelsBalanceReportReqData } from "./GetChannelsBalanceReportReqData";

const ENDPOINT = "/cash_flow/channels_balance";

export class ExportChannelsBalanceCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: any = null;

    constructor(params: GetChannelsBalanceReportReqData, exportType: string) {
        super();
        this.params = { exportType, ...params };
        this.responseType = "text";
        this.endPoint = this.endPoint + "/" + exportType;
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand(this.params);
    }
}
